import { AfterViewInit, Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router, RouterLink } from '@angular/router';
import { signIn, SignInOutput, signOut } from '@aws-amplify/auth';
import { UtilsService } from '../../../services/utils';
import { AuthUtils } from '../auth-common';

@Component({
  selector: 'auth-login',
  imports: [MatFormField, MatInput, MatLabel, MatButton, RouterLink, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements AfterViewInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private utilsService: UtilsService,
    private authUtils: AuthUtils,
  ) {}

  public readonly loginForm = this.fb.group({
    username: this.fb.control(localStorage.getItem('signupEmail') ?? ''),
    password: this.fb.control(''),
    verificationCode: this.fb.control(''),
  });

  async ngAfterViewInit() {}

  async login(_event: SubmitEvent) {
    await signOut();

    const form = this.loginForm.getRawValue();

    if (form.username == null) {
      return;
    }
    if (form.password == null) {
      return;
    }

    await this.signIn();
  }

  protected async signIn() {
    const form = this.loginForm.getRawValue();

    try {
      const signInResult = await signIn({
        username: form.username!,
        password: form.password!.trim(),
      });

      this.processSignInResult(signInResult, form.username!);
    } catch (e) {
      this.authUtils.processAuthError(e);
    }
  }

  protected processSignInResult(signInResult: SignInOutput, userEmail: string) {
    switch (signInResult.nextStep.signInStep) {
      case 'CONFIRM_SIGN_UP':
        localStorage.setItem('signupEmail', userEmail);
        this.utilsService.showError(
          $localize`User verification required. You will be redirected to verification page`,
          () => {
            this.router.navigate(['/auth/verify-email']);
          },
        );
        break;
      case 'DONE':
        localStorage.setItem('signupEmail', userEmail);
        this.router.navigate(['/']);
        break;
      default:
        this.utilsService.showError($localize`Unexpected state: ${signInResult.nextStep.signInStep}`);
    }
  }
}
